import { StateChanges } from '@/store/state';
import makeSlicer from '@/utils/makeSlicer';

const rootSlicer = makeSlicer<StateChanges>();

export const status = rootSlicer('status');
export const updateCount = rootSlicer('updateCount');
export const savedAt = rootSlicer('savedAt');
